import type { JSONContent } from "@tiptap/react";

/** The stored document, or the plain text as paragraphs when only that exists. */
export function initialContent(json: JSONContent | null, text: string): JSONContent {
  if (json) return json;
  return { type: "doc", content: text.split(/\n+/).filter(Boolean).map((line) => ({ type: "paragraph", content: [{ type: "text", text: line }] })) };
}
